module.exports = __webpack_public_path__ + "static/img/hh-police.ad4b1a85.png";